module.exports = __webpack_public_path__ + "static/media/profile.ec8a95f6.png";